import useAppExtensions from '../../extensions/hooks/useAppExtensions';
import { IntegrationPointType } from '../../extensions/types/appExtension';

const useEventAppExtensions = (eventId: number, integrationPoint: IntegrationPointType) => {
    const { data: appExtensions, isError } = useAppExtensions(eventId, integrationPoint);

    if (isError || !appExtensions?.entities?.length) {
        return null;
    }

    // temporary solution to limit one extension per integration point
    return appExtensions.entities[0];
};

export default useEventAppExtensions;
